import { apiClient } from './api/client'
import { buildApiUrl } from '@/config/api'

interface ChaaiAssistantChatResponse {
  reply: string
  solicitationTypeOptions?: Array<{
    id: 'automation' | 'maintenance' | 'improvement_update'
    label: string
    description: string
    prompt: string
  }>
}

type ChaaiConversationTurn = {
  role: 'user' | 'assistant'
  content: string
}

export const chaaiAssistantService = {
  async sendMessage(params: {
    message: string
    conversation: ChaaiConversationTurn[]
    sessionId: string
  }): Promise<ChaaiAssistantChatResponse> {
    const response = await apiClient.post<ChaaiAssistantChatResponse>('/chaai-assistant/chat', {
      message: params.message,
      conversation: params.conversation,
      session_id: params.sessionId,
    })
    return response.data
  },

  async endSession(sessionId: string): Promise<void> {
    await apiClient.post('/chaai-assistant/end-session', {
      session_id: sessionId,
    })
  },

  endSessionKeepalive(sessionId: string): void {
    const token = localStorage.getItem('token')
    if (!token) return

    const url = buildApiUrl('/chaai-assistant/end-session')
    const body = JSON.stringify({ session_id: sessionId })

    try {
      void fetch(url, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          Authorization: `Bearer ${token}`,
        },
        body,
        keepalive: true,
      })
    } catch {
      // Sem fallback adicional: melhor esforço no unload.
    }
  },
}
